import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-heading',
  templateUrl: './lib-heading.component.html',
  styleUrls: ['./lib-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibHeadingComponent {}
